import React from 'react';
import SearchableSelect from '../../../Presentation/components/ui/SearchableSelect';

interface MarketerOption {
  id: number;
  name: string;
  username?: string;
}

// Label shown in the picker: name plus username (when present) so the list is
// searchable by either the developer's name or their username.
const labelForMarketer = (m: MarketerOption): string =>
  m.username ? `${m.name} (${m.username})` : m.name;

interface MarketerDateSelectorProps {
  marketers: MarketerOption[];
  selectedMarketerId: number | null;
  selectedDate: string | null;
  onMarketerChange: (id: number | null) => void;
  onDateChange: (date: string | null) => void;
  loadingMarketers?: boolean;
}

function toIsoDate (input: string): string {
  // Already YYYY-MM-DD.
  return input;
}

function todayIsoDate (): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = (d.getMonth() + 1).toString().padStart(2, '0');
  const dd = d.getDate().toString().padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export const MarketerDateSelector: React.FC<MarketerDateSelectorProps> = ({
  marketers,
  selectedMarketerId,
  selectedDate,
  onMarketerChange,
  onDateChange,
  loadingMarketers = false
}) => {
  const optionLabels = marketers.map(labelForMarketer);
  const selectedMarketer = marketers.find((m) => m.id === selectedMarketerId);
  const selectedLabel = selectedMarketer ? labelForMarketer(selectedMarketer) : '';
  const today = todayIsoDate();

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-gray-200 bg-white p-4 md:flex-row md:items-end">
      <div className="min-w-[240px] flex-1">
        <label className="mb-2 block font-bold">المسوّق</label>
        <SearchableSelect
          options={optionLabels}
          value={selectedLabel}
          disabled={loadingMarketers}
          placeholder="اختر المسوّق"
          disabledPlaceholder="جارٍ التحميل..."
          onChange={(label) => {
            if (!label) {
              onMarketerChange(null);
              return;
            }
            const match = marketers.find((m) => labelForMarketer(m) === label);
            onMarketerChange(match ? match.id : null);
          }}
        />
      </div>

      <div className="min-w-[200px] flex-1">
        <label className="mb-2 block font-bold">التاريخ</label>
        <input
          type="date"
          className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-lg outline-none transition-all focus:border-gray-500"
          value={selectedDate ?? ''}
          max={today}
          onChange={(e) => onDateChange(e.target.value ? toIsoDate(e.target.value) : null)}
        />
      </div>
    </div>
  );
};
